import { Fragment, lazy, Suspense } from "react";
import { Helmet } from "react-helmet";
import MenuRepuestos from "../ecommerceRepuestos/MenuCheckout";
import EcommerceCheckout from "../ecommerceRepuestos/EcommerceCheckout";
import { useLocation } from "react-router-dom";
const Footer = lazy(() => import('../footer/Footer'));
function Checkout() {
    const location = useLocation();
    const cartItems = location.state?.cartItems || [];
    return (
        <Fragment>
            <Helmet>
                <meta
                    name="description"
                    content="Ponte al día con Hyundai. Revisa las noticias relevantes de nuestra marca, no te pierdas de ninguna"
                />
                <meta name="keywords" content="Hyundai, noticias, actualidad" />
                <title>Compra Respuestos</title>
            </Helmet>
            <MenuRepuestos />
            <EcommerceCheckout cartItems={cartItems} />
            <Suspense fallback={<div>Cargando footer...</div>}>
                <Footer />
            </Suspense>
        </Fragment>
    );
}
export default Checkout;